import { Component, Input } from '@angular/core';

export type LoaderColor = 'white' | 'primary' | 'secondary';
export type LoaderSize = 'xs' | 'sm' | 'md' | 'lg';
@Component({
	selector: 'cmv-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
	@Input() size: LoaderSize = 'sm';
	@Input() color: LoaderColor = 'secondary';

	constructor() {}
}
